export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/conference.583a78c.svg";